import { IStateDepartment } from 'src/entity/StateEntity';
import { DEPARTMENT_STATUS_RELOAD, DEPARTMENT_STATUS_REQUEST, DEPARTMENT_STATUS_SUCCESS, DEPARTMENT_STATUS_FAILURE, DEPARTMENT_MODIFY } from 'src/constants/ActionTypes';

const initialState: IStateDepartment = {
  reload: true,
  type: DEPARTMENT_STATUS_RELOAD,
  isFetching: false,
  list: [],
};

export const departmentState = (state: IStateDepartment = initialState, action: IStateDepartment): IStateDepartment => {
  switch (action.type) {
    case DEPARTMENT_STATUS_SUCCESS:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        list: action.list,
      });

    case DEPARTMENT_STATUS_REQUEST:
      return Object.assign({}, state, {
        reload: false,
        isFetching: true,
        type: action.type,
        list: [],
      });

    case DEPARTMENT_STATUS_RELOAD:
      return Object.assign({}, state, {
        reload: true,
        isFetching: false,
        type: action.type,
        list: [],
      });

    case DEPARTMENT_STATUS_FAILURE:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        list: [],
      });
    case DEPARTMENT_MODIFY:
      return Object.assign({}, state, {
        reload: false,
        isFetching: false,
        type: action.type,
        list: action.list,
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/departmentState.ts